import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['body', 'arrow' ]
  static values = { open: Boolean }

  connect() {
    this.element[this.identifier] = this
    this.bodyClass = 'max-h-full'
    this.arrowClass = 'scale-y-mirror'
  }

  toggle() {
    this.openValue = !this.openValue
  }

  open() {
    this.openValue = true
  }

  close(event) {
    if (this.element.contains(event.target) === false && this.openValue) {
      this.openValue = false
    }
  }

  closeImmediately() {
    this.openValue = false
  }

  openValueChanged() {
    if (this.openValue) {
      this._open()
    } else {
      this._close()
    }
  }

  _open() {
    this.element.setAttribute('aria-expanded', 'true')

    this.bodyTarget.classList.add(this.bodyClass)
    this.arrowTarget.classList.add(this.arrowClass)
  }

  _close() {
    this.element.setAttribute('aria-expanded', 'false')

    this.bodyTarget.classList.remove(this.bodyClass)
    this.arrowTarget.classList.remove(this.arrowClass)
  }

}
